import {atom, DefaultValue} from "recoil";
import api from "../services/api";

const localStorageEffect = key => ({setSelf, onSet}) => {
  const queryValue = (new URLSearchParams(window.location.search)).get('token');
  if(queryValue) {
    localStorage.setItem(key, queryValue);
  }

  const savedValue = localStorage.getItem(key);
  if (savedValue != null) {
    api.updateToken(savedValue);
    setSelf(savedValue);
  }

  onSet(newValue => {
    if (newValue instanceof DefaultValue) {
      api.updateToken(null);
      localStorage.removeItem(key);
    } else {
      api.updateToken(newValue);
      localStorage.setItem(key, newValue);
    }
  });
};

const accessTokenState = atom({
  key: 'AccessToken',
  default: null,
  effects_UNSTABLE: [
    localStorageEffect('access_token'),
  ]
});

export default accessTokenState;
